import { render, staticRenderFns } from "./opVerifyFrameRejectDialog.vue?vue&type=template&id=28f11e90&"
import script from "./opVerifyFrameRejectDialog.vue?vue&type=script&lang=js&"
export * from "./opVerifyFrameRejectDialog.vue?vue&type=script&lang=js&"
import style0 from "./opVerifyFrameRejectDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28f11e90')) {
      api.createRecord('28f11e90', component.options)
    } else {
      api.reload('28f11e90', component.options)
    }
    module.hot.accept("./opVerifyFrameRejectDialog.vue?vue&type=template&id=28f11e90&", function () {
      api.rerender('28f11e90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/Prediction/opVerifyFrameRejectDialog.vue"
export default component.exports